<!-- src\components\PricingAccordion\CopyDayModal.vue -->
<template>
  <div
    class="copy-day-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="copy-day-modal-title"
  >
    <h3 id="copy-day-modal-title" class="mb-3">
      <i class="fa fa-copy"></i> Copy Day
    </h3>
    <hr class="title-separator" />
    <div class="copy-day-content">
      <div class="copy-from">
        <span class="mb-2"><b>Copy From:</b></span>
        <div class="mt-2">
          <select
            v-model="copyFrom"
            aria-label="Select the day to copy from"
            class="form-select mb-3"
          >
            <option v-for="day in days" :key="day" :value="day">
              {{ day }}
            </option>
          </select>
        </div>
      </div>
      <div class="copy-to">
        <span class="mb-2"><b>Copy To:</b></span>
        <div class="mt-2">
          <div v-for="day in days" :key="day" class="form-check mb-2">
            <input
              type="checkbox"
              :id="day"
              :value="day"
              v-model="copyTo"
              :aria-label="`Select ${day} to copy to`"
              class="form-check-input"
            />
            <label :for="day" class="form-check-label">{{ day }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button @click="cancel" class="btn btn-secondary me-2">Cancel</button>
      <button @click="copy" class="btn btn-primary">Copy</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DayName } from '../../types/dayNameType';

export default defineComponent({
  name: 'CopyDayModal',
  emits: ['cancel', 'copy'],
  setup(_, { emit }) {
    const copyFrom = ref<DayName>('Monday');
    const copyTo = ref<DayName[]>([]);
    const days: DayName[] = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ];

    const cancel = () => {
      console.log(`copy modal closed.`);
      emit('cancel');
    };

    const copy = () => {
      emit('copy', {
        from: copyFrom.value as DayName,
        to: copyTo.value as DayName[],
      });
    };

    return {
      copyFrom,
      copyTo,
      days,
      cancel,
      copy,
    };
  },
});
</script>

<style scoped>
.copy-day-modal {
  width: 400px;
  padding: 20px;
  background-color: #fff;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  text-align: left;
}

.title-separator {
  border: 0;
  border-top: 1px solid #dee2e6;
  margin-bottom: 1rem;
}

.copy-day-content {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.copy-from,
.copy-to {
  width: 45%;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
  display: flex;
  justify-content: flex-end;
}

.copy-day-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

h2,
h4,
.form-check-label {
  text-align: left;
}
</style>
